import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const highlights = [
  { icon: 'bi-mic-fill',          label: 'Oratory & Debate',  labelMr: 'वक्तृत्व' },
  { icon: 'bi-music-note-beamed', label: 'Classical Dance',   labelMr: 'कथक नृत्य' },
  { icon: 'bi-pen-fill',          label: 'Writing',           labelMr: 'लेखन' },
  { icon: 'bi-book-fill',         label: 'Voracious Reader',  labelMr: 'वाचन' },
];

const HomeAboutPreview = () => {
  const { t, language } = useLanguage();

  return (
    <section className="section-pad" id="about-preview">
      <div className="container">
        <div className="row align-items-center g-5">

          {/* ── Left: Image grid ── */}
          <div className="col-lg-5">
            <div className="img-grid-wrap">
              <div className="img-grid-dot-decor"></div>
              <div className="img-grid-2col">

                <div className="img-grid-main">
                  <div className="placeholder-grid-main">
                    <i className="bi bi-person-bounding-box"></i>
                  </div>
                </div>

                <div className="img-grid-sm">
                  <div className="placeholder-grid-sm placeholder-grid-sm-1">
                    <i className="bi bi-image"></i>
                  </div>
                </div>

                <div className="img-grid-sm">
                  <div className="placeholder-grid-sm placeholder-grid-sm-2">
                    <i className="bi bi-image"></i>
                  </div>
                </div>

              </div>

              {/* Floating quote card */}
              <div className="float-card-primary" style={{position:'absolute',bottom:'-1.5rem',right:'-1.25rem',maxWidth:'210px',zIndex:2}}>
                <div className="float-quote-text">"मी आहे... मी इथेच आहे!"</div>
                <div className="float-quote-sub">— चैत्राली इंदोरे</div>
              </div>
            </div>
          </div>

          {/* ── Right: Content ── */}
          <div className="col-lg-7">
            <span className="eyebrow">
              <i className="bi bi-flower2 me-2"></i>
              {t('common.sheIs')}
            </span>

            <h2 className="section-title">{t('home.aboutTitle')}</h2>
            <div className="divider-brand"></div>

            <p className="body-text">{t('home.aboutText')}</p>

            {/* Mini highlights */}
            <div className="row g-2 mb-4">
              {highlights.map(({ icon, label, labelMr }) => (
                <div className="col-6" key={label}>
                  <div className="d-flex align-items-center gap-2 p-2 rounded-3 bg-card border border-site">
                    <i className={`bi ${icon} text-brand`} style={{fontSize:'1rem'}}></i>
                    <span className="font-sans text-sub" style={{fontSize:'0.85rem',fontWeight:500}}>
                      {language === 'mr' ? labelMr : label}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/who-is-chaitralee" className="btn-brand">
              {t('home.aboutCta')}
              <i className="bi bi-arrow-right"></i>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeAboutPreview;
